import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { alertsAPI, sitesAPI } from '../services/api';
const STATUS_BADGE = {
  new:{bg:'#fcebeb',color:'#a32d2d',label:'חדשה'},
  acknowledged:{bg:'#faeeda',color:'#854f0b',label:'התקבלה'},
  in_treatment:{bg:'#e6f1fb',color:'#185fa5',label:'בטיפול'},
  resolved:{bg:'#eaf3de',color:'#3b6d11',label:'טופל'}
};
export default function HistoryPage() {
  const [alerts,setAlerts]=useState([]);
  const [sites,setSites]=useState([]);
  const [loading,setLoading]=useState(false);
  const [filters,setFilters]=useState({site_id:'',status:'',from:'',to:''});
  useEffect(()=>{sitesAPI.getAll().then(r=>setSites(r.data));fetchAlerts({});},[]);
  const fetchAlerts=async(params)=>{
    setLoading(true);
    try{
      const clean=Object.fromEntries(Object.entries(params).filter(([,v])=>v));
      const{data}=await alertsAPI.getHistory({...clean,limit:200});
      setAlerts(data);
    }finally{setLoading(false);}
  };
  const responseTime=(a)=>{
    if(!a.acknowledged_at)return'--';
    const s=Math.floor((new Date(a.acknowledged_at)-new Date(a.triggered_at))/1000);
    return s<60?s+'s':Math.floor(s/60)+'m '+s%60+'s';
  };
  const handleExport=()=>{
    const headers=['תאריך','שעה','אתר','עיר','קומה','חדר','לחצן','סטטוס','זמן תגובה','מטפל'];
    const rows=alerts.map(a=>[
      format(new Date(a.triggered_at),'dd/MM/yyyy'),
      format(new Date(a.triggered_at),'HH:mm:ss'),
      a.site_name,a.site_city,a.floor||'',a.room||'',
      a.button_type,a.status,responseTime(a),a.acknowledged_by_name||''
    ]);
    const csv=[headers,...rows].map(r=>r.map(v=>'"'+v+'"').join(',')).join('\n');
    const blob=new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8;'});
    const url=URL.createObjectURL(blob);
    const a=document.createElement('a');
    a.href=url;a.download='semsim_'+format(new Date(),'yyyyMMdd')+'.csv';a.click();
  };
  return(
    <div style={{padding:24,fontFamily:'system-ui,Arial,sans-serif'}} dir="rtl">
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20}}>
        <h2 style={{fontSize:18,fontWeight:600,margin:0}}>היסטוריית אירועים</h2>
        <button onClick={handleExport} style={{background:'#eaf3de',color:'#3b6d11',border:'none',borderRadius:6,padding:'7px 16px',fontSize:13,cursor:'pointer',fontWeight:500}}>Export CSV</button>
      </div>
      <div style={{display:'flex',gap:10,marginBottom:14,flexWrap:'wrap'}}>
        <select style={{padding:'7px 10px',border:'1px solid #ddd',borderRadius:6,fontSize:13}} value={filters.site_id} onChange={e=>setFilters(p=>({...p,site_id:e.target.value}))}>
          <option value="">כל האתרים</option>
          {sites.map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
        <select style={{padding:'7px 10px',border:'1px solid #ddd',borderRadius:6,fontSize:13}} value={filters.status} onChange={e=>setFilters(p=>({...p,status:e.target.value}))}>
          <option value="">כל הסטטוסים</option>
          {Object.entries(STATUS_BADGE).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
        </select>
        <input type="date" style={{padding:'7px 10px',border:'1px solid #ddd',borderRadius:6,fontSize:13}} value={filters.from} onChange={e=>setFilters(p=>({...p,from:e.target.value}))}/>
        <input type="date" style={{padding:'7px 10px',border:'1px solid #ddd',borderRadius:6,fontSize:13}} value={filters.to} onChange={e=>setFilters(p=>({...p,to:e.target.value}))}/>
        <button onClick={()=>fetchAlerts(filters)} style={{background:'#1a1f2e',color:'#fff',border:'none',borderRadius:6,padding:'7px 18px',fontSize:13,cursor:'pointer'}}>חפש</button>
      </div>
      <div style={{fontSize:13,color:'#888',marginBottom:14}}>{loading?'טוען...':alerts.length+' התראות'}</div>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
        <thead>
          <tr>{['תאריך ושעה','אתר','מיקום','לחצן','סטטוס','זמן תגובה','מטפל'].map(h=>(
            <th key={h} style={{padding:'8px 10px',textAlign:'right',fontSize:11,fontWeight:600,color:'#888',borderBottom:'2px solid #eee'}}>{h}</th>
          ))}</tr>
        </thead>
        <tbody>
          {alerts.map(a=>{
            const b=STATUS_BADGE[a.status]||STATUS_BADGE.new;
            return(
              <tr key={a.id} style={{borderBottom:'1px solid #f5f5f5'}}>
                <td style={{padding:'10px'}}>
                  <div style={{fontWeight:500}}>{format(new Date(a.triggered_at),'dd/MM/yyyy')}</div>
                  <div style={{fontSize:11,color:'#888'}}>{format(new Date(a.triggered_at),'HH:mm:ss')}</div>
                </td>
                <td style={{padding:'10px'}}>
                  <div style={{fontWeight:500}}>{a.site_name}</div>
                  <div style={{fontSize:11,color:'#888'}}>{a.site_city}</div>
                </td>
                <td style={{padding:'10px'}}>{[a.floor,a.room].filter(Boolean).join(' / ')||'--'}</td>
                <td style={{padding:'10px'}}>{a.button_type==='mushroom'?'Mushroom':'Hidden'}</td>
                <td style={{padding:'10px'}}>
                  <span style={{fontSize:11,padding:'2px 10px',borderRadius:50,background:b.bg,color:b.color,fontWeight:500}}>{b.label}</span>
                </td>
                <td style={{padding:'10px'}}>{responseTime(a)}</td>
                <td style={{padding:'10px'}}>{a.acknowledged_by_name||'--'}</td>
              </tr>
            );
          })}
          {alerts.length===0&&!loading&&(
            <tr><td colSpan={7} style={{textAlign:'center',padding:40,color:'#aaa'}}>לא נמצאו התראות</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
